export const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="w-12 h-12 border-4 border-wmp-100 border-t-wmp-500 rounded-full animate-spin mb-4" />
      <p className="text-gray-500 text-lg font-medium">
        Authentication in progress...
      </p>
    </div>
  );
};
